// extracted by mini-css-extract-plugin
module.exports = {"win-card-box":"gS","winCardBox":"gS","win-card-btn-detail":"gT","winCardBtnDetail":"gT","win-card-dec":"gU","winCardDec":"gU","win-card-name":"gV","winCardName":"gV"};